// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__Aab-u","addWidgetButton":"Header_addWidgetButton__NPDwc","dashboardTabs":"Header_dashboardTabs__3_1Iz","active":"Header_active__32Gee"};